import React from "react";
import Navbar from "../components/Navbar";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen" style={{ background: "#080605" }}>
      <Navbar />

      <div className="container-custom pt-32 pb-24">
        <div className="max-w-3xl mx-auto">
          {/* Back link top */}
          <a
            href="/#entradas"
            className="font-sans text-xs tracking-[0.2em] uppercase text-[#E57324] hover:text-[#F08A46] transition-colors inline-block mb-8"
          >
            ← Вернуться на главную
          </a>

          {/* Title */}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F2E9DE] mb-2">
            ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
          </h1>

          <p className="font-sans text-sm text-[#A99F96] mb-12">
            Дата публикации: 05.05.2026
          </p>

          {/* Divider */}
          <div className="w-full h-px mb-12" style={{ background: "rgba(242, 233, 222, 0.1)" }} />

          {/* Content */}
          <div className="space-y-10 font-sans text-base lg:text-lg font-light leading-relaxed tracking-wide text-[#F2E9DE]">
            {/* 1. Общие положения */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                1. Общие положения
              </h2>
              <p className="mb-3">
                1.1. Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и действует в отношении всех персональных данных, которые Оператор может получить от посетителей веб-сайта veronika-valova.ru (далее — Сайт).
              </p>
              <p className="mb-3">
                1.2. Оператором персональных данных является:
                <br />
                Валова Вероника Сергеевна
                <br />
                Самозанятая, ИНН 550726323381
                <br />
                E-mail: verona_piano@mail.ru
              </p>
              <p className="mb-3">
                1.3. Использование Сайта означает безоговорочное согласие пользователя с настоящей Политикой и указанными в ней условиями обработки его персональных данных. В случае несогласия с этими условиями пользователь должен воздержаться от использования Сайта.
              </p>
            </section>

            {/* 2. Основные понятия */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                2. Основные понятия
              </h2>
              <p className="mb-2">
                • Персональные данные — любая информация, относящаяся к прямо или косвенно определенному, или определяемому физическому лицу (субъекту персональных данных).
              </p>
              <p className="mb-2">
                • Обработка персональных данных — любое действие или совокупность действий с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, использование, обезличивание, блокирование, удаление, уничтожение.
              </p>
              <p className="mb-2">
                • Файлы cookie — небольшие текстовые файлы, размещаемые на устройстве пользователя при посещении Сайта.
              </p>
            </section>

            {/* 3. Цели обработки */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                3. Цели обработки персональных данных
              </h2>
              <p className="mb-3">
                Оператор обрабатывает персональные данные в следующих целях:
              </p>
              <p className="mb-2">
                • Предоставление доступа к информации и материалам, размещённым на Сайте, включая сведения о спектакле и мероприятиях.
              </p>
              <p className="mb-2">
                • Анализ действий посетителей на Сайте и улучшение его работы с использованием файлов cookie и сервиса веб-аналитики Яндекс.Метрика (ООО «ЯНДЕКС», ИНН 7736207543).
              </p>
              <p className="mb-2">
                • Обработка обращений и запросов пользователей, полученных через форму обратной связи на Сайте, для ответа на них по указанным контактам.
              </p>
            </section>

            {/* 4. Правовые основания */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                4. Правовые основания обработки персональных данных
              </h2>
              <p className="mb-3">
                4.1. Обработка персональных данных осуществляется на основании:
                <br />
                • согласия субъекта персональных данных на обработку его персональных данных;
                <br />
                • настоящей Политики.
              </p>
              <p className="mb-3">
                4.2. Согласие предоставляется пользователем путём проставления галочки в чекбоксе «Я даю добровольное согласие на обработку персональных данных…» в форме обратной связи, а также путём нажатия кнопки «Принять» на всплывающем баннере об использовании cookie-файлов.
              </p>
              <p className="mb-3">
                4.3. Пользователь вправе отозвать своё согласие в любое время, направив соответствующий запрос на электронную почту Оператора verona_piano@mail.ru.
              </p>
            </section>

            {/* 5. Категории и перечень */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                5. Категории и перечень обрабатываемых данных
              </h2>
              <p className="mb-3">
                Оператор может обрабатывать следующие данные:
              </p>
              <p className="mb-2">
                • Обезличенные данные, автоматически передаваемые при посещении Сайта: IP-адрес, тип браузера, операционная система, информация о cookie-файлах, данные о посещённых страницах и действиях на Сайте.
              </p>
              <p className="mb-2">
                • Персональные данные, которые пользователь самостоятельно указывает в форме обратной связи: имя, контактный телефон, адрес электронной почты (объём зависит от заполняемых полей формы).
              </p>
            </section>

            {/* 6. Порядок и условия */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                6. Порядок и условия обработки персональных данных
              </h2>
              <p className="mb-3">
                6.1. Обработка персональных данных осуществляется путём сбора, записи, систематизации, накопления, хранения, обезличивания, уничтожения.
              </p>
              <p className="mb-3">
                6.2. Обезличенные данные пользователей, собираемые с помощью сервиса Яндекс.Метрика, передаются ООО «ЯНДЕКС» для проведения статистического анализа. Обработка осуществляется на серверах, находящихся на территории Российской Федерации.
              </p>
              <p className="mb-3">
                6.3. Оператор не осуществляет трансграничную передачу персональных данных.
              </p>
              <p className="mb-3">
                6.4. Срок обработки: данные обрабатываются до момента отзыва согласия субъектом или до достижения целей обработки.
              </p>
              <p className="mb-3">
                6.5. Оператор принимает разумные организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, копирования, распространения.
              </p>
            </section>

            {/* 7. Права субъекта */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                7. Права субъекта персональных данных
              </h2>
              <p className="mb-3">
                Субъект персональных данных вправе:
              </p>
              <p className="mb-2">
                • получать информацию, касающуюся обработки его персональных данных;
              </p>
              <p className="mb-2">
                • требовать уточнения, блокирования или уничтожения своих персональных данных в случаях, предусмотренных законодательством;
              </p>
              <p className="mb-2">
                • отозвать согласие на обработку персональных данных;
              </p>
              <p className="mb-2">
                • обжаловать действия или бездействие Оператора в уполномоченном органе по защите прав субъектов персональных данных или в судебном порядке.
              </p>
              <p className="mt-3">
                Для реализации своих прав субъект направляет запрос на электронную почту Оператора verona_piano@mail.ru.
              </p>
            </section>

            {/* 8. Использование файлов cookie */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                8. Использование файлов cookie
              </h2>
              <p className="mb-3">
                8.1. Сайт использует файлы cookie для корректной работы и аналитики.
              </p>
              <p className="mb-3">
                8.2. При первом посещении Сайта пользователь информируется об использовании cookie с помощью всплывающего баннера. Нажатие кнопки «Принять» означает согласие на обработку cookie-файлов в соответствии с настоящей Политикой.
              </p>
              <p className="mb-3">
                8.3. Пользователь может отключить cookie в настройках браузера, однако это может повлиять на функционирование Сайта.
              </p>
            </section>

            {/* 9. Заключительные положения */}
            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                9. Заключительные положения
              </h2>
              <p className="mb-3">
                9.1. Оператор вправе вносить изменения в настоящую Политику без согласия пользователя.
              </p>
              <p className="mb-3">
                9.2. Новая редакция Политики вступает в силу с момента её публикации на Сайте, если иное не предусмотрено новой редакцией.
              </p>
              <p className="mb-3">
                9.3. Действующая редакция Политики всегда доступна по постоянной ссылке в нижней части Сайта (футере).
              </p>
            </section>
          </div>

          {/* Bottom divider */}
          <div className="w-full h-px mt-16 mb-8" style={{ background: "rgba(242, 233, 222, 0.1)" }} />

          <a
            href="/#entradas"
            className="font-sans text-xs tracking-[0.2em] uppercase text-[#E57324] hover:text-[#F08A46] transition-colors"
          >
            ← Вернуться на главную
          </a>
        </div>
      </div>
    </main>
  );
}
